import { useHistory } from "react-router-dom";

export function useRouter() {
  const history = useHistory();
  function handleGoNextPage(pathname: string, search?: string, state?: any) {
    history.push({
      pathname,
      search,
      state,
    });
    window.scrollTo(0, 0);
  }
  return {
    handleGoNextPage,
  };
}
